import React, { useCallback, useEffect, useRef } from 'react';
import { useSeparateLayoutSheet } from '../../layout/separateLayoutSheet';

/**
 * Links the calculator inputs with the SeparateContentLayout sheet it is rendered in (no-op outside it):
 * focusing an input expands the sheet, expanding the sheet focuses the last focused input (the "from" input by default).
 */
export const useCalculatorSheetFocus = () => {
    const sheet = useSeparateLayoutSheet();
    const fromInputRef = useRef<HTMLInputElement | null>(null);
    const toInputRef = useRef<HTMLInputElement | null>(null);
    const lastFocusedRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => sheet?.registerFocusTarget(() => lastFocusedRef.current ?? fromInputRef.current), [sheet]);

    const onInputFocus = useCallback(
        (e: React.FocusEvent<HTMLInputElement>) => {
            lastFocusedRef.current = e.currentTarget;
            sheet?.open();
        },
        [sheet],
    );

    return { fromInputRef, toInputRef, onInputFocus };
};
